const o = {
  loopGap: 5,
  multiple: !1,
  loop: !1,
  iconSize: 24,
  loopSize: {
    iconCircle: 32,
    icon: 18
  }
}, l = 300;
export {
  l as ANIMATION_TIME,
  o as defaultProps
};
//# sourceMappingURL=const.mjs.map
